import { Autocomplete as AutocompleteInput } from './Autocomplete';
import { wrapInLabel } from '../NewInputLabelWrapper';
import { withFormMeta } from '../../FormMeta';

export default withFormMeta(wrapInLabel(AutocompleteInput));
